export function getPollingInterval():number {
    const min = 50;
    const max = 70;
    const seconds = Math.floor(Math.random() * (max - min + 1) + min);

    return seconds * 1000;
}